import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TextInput from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { StepEvent, StepParams } from './StepParams'

export const LinkedInContract = observer(
  ({ onStepEvent, onClose, progress, linkedInContractForm }: StepParams) => {
    return (
      <Modal
        title={i18n.t('ats.job_details.promotion.vonq.linkedin.contract_step.title')}
        description={i18n.t('ats.job_details.promotion.vonq.linkedin.contract_step.description')}
        illustration="document-edit"
        onClose={onClose}
        footer={
          <Button
            disabled={!linkedInContractForm.isComplete}
            onClick={() => onStepEvent(StepEvent.Next)}
          >
            {i18n.t('ats.job_details.promotion.vonq.linkedin.contract_step.next')}
          </Button>
        }
        progress={progress}
      >
        <Box gap="s16" flexDirection="column">
          <TextInput
            label={i18n.t(
              'ats.job_details.promotion.vonq.linkedin.contract_step.fields.company_id'
            )}
            field={linkedInContractForm.get('Company_ID')}
            mandatory
          />
          <TextInput
            label={i18n.t(
              'ats.job_details.promotion.vonq.linkedin.contract_step.fields.recruiter_contract_id'
            )}
            field={linkedInContractForm.get('recruiter_contract_id')}
            mandatory
          />
        </Box>
      </Modal>
    )
  }
)
